module.exports = __webpack_public_path__ + "media/images/about-us/PGA/New England PGA-a70babc9c6decb14ee9ff103a1035cfe.png";